import utc from "dayjs/plugin/utc";
import updatedLocale from "dayjs/plugin/updateLocale";
import { CalDelivery, DeliveryWithExtras } from "@/app/types/types";
import { User } from "@/app/_components/context/user-context";
import { IconCircleCheck } from "@tabler/icons-react";
import dayjs from "dayjs";

interface DeliveryCalendarCardProps {
  deliveries: Record<string, DeliveryWithExtras[]>;
  userPermissions: string[];
  user: User;
}

const MobileDeliveryCalendarCard = ({
  deliveries,
  user,
  userPermissions,
}: DeliveryCalendarCardProps) => {
  dayjs.extend(utc);
  dayjs.extend(updatedLocale);
  dayjs.updateLocale("en", {
    weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  });

  const deliveryDataToTZ: { [key: string]: CalDelivery[] } =
    deliveries &&
    Object.keys(deliveries).reduce(
      (acc, key) => {
        const localDate = new Date(key);
        const dayToAdd = `${dayjs.utc(localDate).format("YYYY-MM-DD")}`;
        acc[dayToAdd] = [];
        return acc;
      },
      {} as { [key: string]: CalDelivery[] },
    );

  if (deliveries) {
    Object.entries(deliveries).forEach(([key, value]) => {
      value.forEach((delivery) => {
        const localDate = new Date(delivery.delivery.scheduledDeliveryDate);
        const dayToAdd = `${dayjs.utc(localDate).local().format("YYYY-MM-DD")}`;
        if (deliveryDataToTZ[dayToAdd]) {
          deliveryDataToTZ[dayToAdd].push(delivery.delivery);
        }
      });
    });
  }

  return (
    <div className="flex flex-col gap-4">
      {deliveryDataToTZ &&
        Object.entries(deliveryDataToTZ).map(([key, value], index) => {
          const dayLabel = dayjs.utc(key).utc(true).format("ddd, MMM D");

          return (
            <div
              key={`mobile-delivery-${index}`}
              className="flex flex-col gap-2"
            >
              <div className="text-xs font-medium text-muted-foreground bg-muted px-2 py-1 rounded-md">
                {dayLabel}
              </div>
              <div className="flex flex-col gap-2">
                {value.length > 0 ? (
                  value
                    .sort(
                      (a, b) =>
                        new Date(a.scheduledDeliveryDate).getTime() -
                        new Date(b.scheduledDeliveryDate).getTime(),
                    )
                    .map((delivery) => {
                      const formatted = new Date(
                        delivery.scheduledDeliveryDate,
                      ).toLocaleString("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      });
                      const customerName =
                        userPermissions &&
                        (userPermissions.includes("VIEW_OTHER_CUSTOMERS") ||
                        delivery.salesPerson === user.name
                          ? delivery.customer
                          : "*****");

                      return (
                        <div
                          key={`${delivery.id}`}
                          className="flex flex-col gap-1 rounded-lg border border-border bg-card p-3 text-sm"
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2 text-foreground">
                              <IconCircleCheck size={16} color="#42f58d" />
                              <span className="font-medium">
                                {delivery.stockNumber}
                              </span>
                            </div>
                            <span className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded">
                              {formatted}
                            </span>
                          </div>
                          <span className="text-xs text-muted-foreground">
                            {delivery.carDescription}
                          </span>
                          <div className="flex justify-between text-xs text-muted-foreground">
                            <span>{customerName}</span>
                            <span>{delivery.salesPerson}</span>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div className="text-center text-xs text-muted-foreground py-4">
                    No deliveries scheduled
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default MobileDeliveryCalendarCard;
